export default __webpack_public_path__ + "static/media/clipboard-list-outline.66ca3276.svg";